import React, { useState } from "react";
import { Rnd } from "react-rnd";

interface BudgetItem {
	name: string;
	width: number;
	height: number;
	position: { x: number; y: number };
	bgColor: string;
	color: string;
}

const initialBudgets: BudgetItem[] = [
	{ name: "Santé", width: 472, height: 430, position: { x: 0, y: 0 }, bgColor: "#2E4991", color: "white" },
	{
		name: "Reste de la protection sociale",
		width: 251,
		height: 430,
		position: { x: 472, y: 0 },
		bgColor: "#0A2F6E",
		color: "white",
	},
	{ name: "Retraites", width: 723, height: 353, position: { x: 0, y: 430 }, bgColor: "#02B5E3", color: "white" },
	{ name: "Défense", width: 200, height: 154, position: { x: 723, y: 0 }, bgColor: "#02B5E4", color: "black" },
	{ name: "Sécurité", width: 163, height: 154, position: { x: 923, y: 0 }, bgColor: "#F7EB7D", color: "black" },
	{
		name: "Infrastructures",
		width: 144,
		height: 75,
		position: { x: 1086, y: 0 },
		bgColor: "#6856CD",
		color: "white",
	},
	{ name: "Justice", width: 63, height: 75, position: { x: 1230, y: 0 }, bgColor: "#7AF3B4", color: "black" },
	{ name: "Environnement", width: 204, height: 85, position: { x: 1086, y: 69 }, bgColor: "#F3A5E1", color: "white" },
	{
		name: "Charge de la dette",
		width: 200,
		height: 154,
		position: { x: 723, y: 154 },
		bgColor: "#FD745D",
		color: "white",
	},
	{ name: "Recherche", width: 195, height: 154, position: { x: 923, y: 154 }, bgColor: "#75F5B2", color: "black" },
	{
		name: "Culture et loisirs",
		width: 172,
		height: 154,
		position: { x: 1118, y: 154 },
		bgColor: "#F6EB7D",
		color: "black",
	},
	{
		name: "Soutien aux activités économiques",
		width: 308,
		height: 192,
		position: { x: 723, y: 308 },
		bgColor: "#6758CD",
		color: "white",
	},
	{
		name: "Transports et équipements collectifs",
		width: 261,
		height: 192,
		position: { x: 1030, y: 308 },
		bgColor: "#0AB5E4",
		color: "black",
	},
	{ name: "Éducation", width: 323, height: 276, position: { x: 723, y: 500 }, bgColor: "#F5A4E1", color: "black" },
	{
		name: "Fonctionnement des administrations publiques",
		width: 241,
		height: 276,
		position: { x: 1048, y: 500 },
		bgColor: "#FE755D",
		color: "white",
	},
];

export default function BudgetTreemap() {
	const [budgets, setBudgets] = useState<BudgetItem[]>(initialBudgets);
	const [totalBudget, setTotalBudget] = useState<number>(1000);

	const containerWidth = 1290;
	const containerHeight = 782;
	const totalArea = containerHeight * containerWidth;

	const handleResize = (
		index: number,
		newWidth: number,
		newHeight: number,
		newPosition: { x: number; y: number }
	): void => {
		console.log("Resizing", index, newWidth, newHeight, newPosition);
		const updatedBudgets = [...budgets];
		updatedBudgets[index].width = newWidth;
		updatedBudgets[index].height = newHeight;
		updatedBudgets[index].position = newPosition;
		setBudgets(updatedBudgets);
		const newTotalBudget = updatedBudgets.reduce(
			(acc, item) => acc + +(((item.width * item.height) / totalArea) * 1000).toFixed(0),
			0
		);
		setTotalBudget(newTotalBudget);
	};

	const containerStyle: React.CSSProperties = {
		width: `${containerWidth}px`,
		height: `${containerHeight}px`,
		border: "1px solid #ccc",
		backgroundColor: "#1a1a1a",
		color: "white",
		position: "relative",
		overflow: "hidden",
	};

	const boxStyle: React.CSSProperties = {
		color: "white",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		textAlign: "center",
		border: "1px solid white",
		boxSizing: "border-box",
		position: "absolute",
	};

	const headerStyle: React.CSSProperties = {
		fontSize: "24px",
		fontWeight: "bold",
		marginBottom: "20px",
	};

	return (
		<div>
			<div style={headerStyle}>Répartition de {totalBudget.toFixed(0)}€ de dépenses publiques</div>
			<div style={containerStyle}>
				{budgets.map((item, index) => {
					const area = item.width * item.height;
					const value = (area / totalArea) * 1000;
					return (
						<Rnd
							key={item.name}
							size={{ width: item.width, height: item.height }}
							position={item.position}
							bounds="parent"
							onResize={(e, direction, ref, delta, position) => {
								handleResize(index, ref.offsetWidth, ref.offsetHeight, position);
							}}
							onDragStop={(e, d) => {
								const updatedBudgets = [...budgets];
								updatedBudgets[index].position = { x: d.x, y: d.y };
								setBudgets(updatedBudgets);
							}}
							style={{ ...boxStyle, backgroundColor: item.bgColor, color: item.color }}
						>
							<div>
								<strong>{item.name}</strong>
								<br />
								{value.toFixed(0)}€
							</div>
						</Rnd>
					);
				})}
			</div>
		</div>
	);
}
